import React, { PureComponent } from "react";

import { Icon, Button } from "..";
import style from "./Panel.module.scss";

class ServicePanel extends PureComponent {

  render() {
    const { title, caption, pattern, id, current_data, glossary, locale, slug } = this.props;
    // console.log("CURRENT DATA", current_data)

    return (
      <div className={style.container}>
        <div className={style.service__info}>
          <div className={style.service__header}>
            <Icon type="plus" className={style.service__icon} />
            <h4 className={style.service__name}>{title}</h4>
          </div>
          <p className={style.service__caption}>{caption}</p>
          <div className={style.button__panel}>
            <Button buttonName={glossary.learnMore || 'Learn More'} type="redirect" link={`/${locale}/service-details/${slug}`} />
          </div>
        </div>
        <div className={style.service__pattern}>
          <div style={{
            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            backgroundImage: `url(${pattern})`,
            backgroundSize: title === 'Architecture' ? 50 : 80
          }} />
        </div>
      </div>
    )
  }
}

export default ServicePanel;
